import { useState, useEffect } from 'react'
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { useAuth } from '../context/AuthContext'
import { getTeacherAccessibleClasses, getClassDisplayName } from '../utils/classUtils'
import supabase from '../supabaseClient'

function ClassSelector({ selectedClass, setSelectedClass }) {
  const [classes, setClasses] = useState([])
  const { user, userRole } = useAuth()

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        if (userRole === 'admin' || userRole === 'super_admin') {
          // Admin sees all classes
          const { data, error } = await supabase.from('classes').select('*')
          if (error) throw error
          setClasses(data.map(cls => ({ ...cls, isSubstitute: false })))
        } else if (user?.id) {
          // Teachers see their accessible classes (regular + substitute)
          const data = await getTeacherAccessibleClasses(user.id, '*')
          setClasses(data)
        }
      } catch (error) {
        console.error('Error fetching classes:', error)
        setClasses([])
      }
    }

    fetchClasses()
  }, [user?.id, userRole])

  return (
    <FormControl fullWidth>
      <InputLabel>Select Class</InputLabel>
      <Select
        value={selectedClass}
        onChange={(e) => setSelectedClass(e.target.value)}
        label="Select Class"
        // size="small"
      >
        <MenuItem value="">Select a class</MenuItem>
        {classes.map((cls) => (
          <MenuItem key={cls.id} value={cls.id}>
            {getClassDisplayName(cls)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default ClassSelector
